/* oxlint-disable typescript/no-unnecessary-condition -- migration untrusted data */
// Migration: v3 → v4
// `showName` became a defaulted field (default: true) on named widgets.
// The other v4 changes are additive/loosening and need no transformation:
// new `painScale` widget type (which has no `showName`), optional `input.unit`,
// and relaxed `reference.fieldName`.

import type { MigratableTemplateContent } from './types';

const NAMED_WIDGET_TYPES = new Set([
  'checkbox',
  'datePicker',
  'dateRangePicker',
  'inputEmail',
  'inputNumber',
  'inputText',
  'numberSelect',
  'radio',
  'select',
  'textarea',
  'timePicker',
]);

export const migrateV3ToV4 = (data: MigratableTemplateContent): void => {
  const widgets = data.widgets;

  if (!widgets || typeof widgets !== 'object' || Array.isArray(widgets)) {
    data.version = '4';

    return;
  }

  for (const widget of Object.values(widgets)) {
    if (
      widget.type !== undefined &&
      NAMED_WIDGET_TYPES.has(widget.type) &&
      widget.showName === undefined
    ) {
      widget.showName = true;
    }
  }

  data.version = '4';
};
